import React, {
  useEffect,
  useState,
  useCallback,
  useContext,
  useRef,
} from "react";

import * as Yup from "yup";
import { useFormik } from "formik";
import AOS from "aos";
import { useLocation, useNavigate } from "react-router-dom";
import { Logindetail } from "../../context/Logindetail.js";
import instance from "../../Config/Config.js";
import { getprofile_fun } from "../../api/Dashboardapi.js";
import toast from "react-hot-toast";

const AddressForm = ({ setting_data }) => {
  const [spinner, setspinner] = useState(false);
  const location = useLocation();
  const { token, detail_info, setdetail_info } = useContext(Logindetail);
  const totalPrice = location.state?.total;
  const previousRoute = location.state?.from;
  const fromType = location.state?.type;
  const [selectedRole, setSelectedRole] = useState("1"); // 1: Manufacturer, 2: Agency supplier, 3: Dealers
  const [loadingProfile, setLoadingProfile] = useState(false);

  const initvalue = {
    country: "",
    state: "",
    requirement: "",
    city: "",
    postal_code: "",
    selection: "",
  };

  const updateschema = Yup.object().shape({
    country: Yup.string().required("Country is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    requirement: Yup.string().required("Address is required"),
    postal_code: Yup.string().required("Postal code is required"),
    selection: Yup.string().required("Address type is required"),
  });

  const Formik = useFormik({
    initialValues: initvalue,
    validationSchema: updateschema,
    onSubmit: async (value, { setErrors, resetForm }) => {
      const data = {
        address: value.requirement,
        country_id: parseInt(value.country),
        state_id: parseInt(value.state),
        city_id: parseInt(value.city),
        postal_code: value.postal_code,
        type: parseInt(value.selection),
      };

      try {
        const responseApi = await instance.post("address", data);
        if (previousRoute === "profile") {
          router("/user/myprofile");
        } else {
          router("/checkout", {
            state: {
              total: totalPrice,
            },
          });
        }
      } catch (err) {
        console.error("Failed to save address:", err);
      }
    },
  });

  useEffect(() => {
    if (Formik.submitCount > 0 && Object.keys(Formik.errors).length > 0) {
      const errorMessages = Object.values(Formik.errors);
      toast.error(errorMessages[0]);
    }
  }, [Formik.submitCount]);

  const initvalue2 = {
    GSTIN: "",
    Company_Name: "",
    PhoneNumber: "",
    Alternate_Phone_Number: "",
    country: "",
    state: "",
    requirement: "",
    city: "",
    postal_code: "",
  };

  const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  const updateschema2 = Yup.object().shape({
    Company_Name: Yup.string().required("Company Name is required"),
    GSTIN: selectedRole === "2"
      ? Yup.string().matches(gstinRegex, {
        message: "Enter a valid GSTIN (e.g., 33AABCJ1087G1ZU)",
        excludeEmptyString: true,
      })
      : Yup.string()
        .required("GSTIN is required")
        .matches(gstinRegex, "Enter a valid GSTIN (e.g., 33AABCJ1087G1ZU)"),
    country: Yup.string().required("Country is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    requirement: Yup.string().required("Address is required"),
    postal_code: Yup.string().required("Postal code is required"),
    PhoneNumber: Yup.string()
      .min(5, "Phone Number Minimum 5 digits")
      .required("Phone Number is required")
      .matches(/^[0-9]+$/, "Invalid Phone Number"),
  });

  const Formik2 = useFormik({
    initialValues: initvalue2,
    validationSchema: updateschema2,
    onSubmit: async (value, { setErrors, resetForm }) => {
      const data = {
        company: selectedRole == 0 ? "0" : "1",
        company_name: value.Company_Name,
        gst: value.GSTIN,
        c_phone_1: value.PhoneNumber,
        c_phone_2: value.Alternate_Phone_Number,
        c_address: value.requirement,
        c_country: parseInt(value.country),
        c_state: parseInt(value.state),
        c_city: parseInt(value.city),
        c_postal: value.postal_code,
        user_type: parseInt(selectedRole),
      };

      try {
        const responseApi = await instance.post("company_info", data);
        if (previousRoute === "profile") {
          router("/user/myprofile");
        } else {
          router("/checkout", {
            state: {
              total: totalPrice,
            },
          });
        }
      } catch (err) {
        console.error("Failed to save company information:", err);
      }
    },
  });

  useEffect(() => {
    if (Formik2.submitCount > 0 && Object.keys(Formik2.errors).length > 0) {
      const errorMessages = Object.values(Formik2.errors);
      toast.error(errorMessages[0]);
    }
  }, [Formik2.submitCount]);

  useEffect(() => {
    AOS.init({
      duration: 1500,
    });
    
    const loadProfile = async () => {
      try {
        setLoadingProfile(true);
        const res = await getprofile_fun();
        if (res?.data) {
          Formik2.setValues({
            Company_Name: res.data.company_name || "",
            GSTIN: res.data.gst || "",
            PhoneNumber: res.data.c_phone_1 || "",
            Alternate_Phone_Number: res.data.c_phone_2 || "",
            country: res.data.c_country || "",
            state: res.data.c_state || "",
            requirement: res.data.c_address || "",
            city: res.data.c_city || "",
            postal_code: res.data.c_postal || "",
          });
          
          if (res.data.c_country) setSelectedCountryId(res.data.c_country);
          if (res.data.c_state) setSelectedStateId(res.data.c_state);
          if (res.data.user_type) {
             setSelectedRole(res.data.user_type.toString());
          }
        }
      } catch (err) {
        console.error("Failed to fetch profile:", err);
      } finally {
        setLoadingProfile(false);
      }
    };

    loadProfile();
  }, []);

  const router = useNavigate();
  const [countryList, setCountryList] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState(null);
  const [stateList, setStateList] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState(null);
  const [cityList, setCityList] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await instance.get("get_country");
        setCountryList(res?.data?.data || []);
      } catch (err) {
        console.error("❌ Failed to fetch countries:", err);
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      if (!selectedCountryId) {
        setStateList([]);
        setSelectedStateId(null);
        setCityList([]);
        return;
      }

      try {
        const res = await instance.get("get_state", {
          params: { country_id: selectedCountryId },
        });
        setStateList(res?.data?.data || []);
        setSelectedStateId(null);
        setCityList([]);
      } catch (err) {
        console.error("❌ Failed to fetch states:", err);
        setStateList([]);
      }
    };
    fetchStates();
  }, [selectedCountryId]);

  useEffect(() => {
    const fetchCities = async () => {
      if (!selectedCountryId || !selectedStateId) {
        setCityList([]);
        return;
      }

      try {
        const res = await instance.get("get_city", {
          params: {
            country_id: selectedCountryId,
            state_id: selectedStateId,
          },
        });
        setCityList(res?.data?.data || []);
      } catch (err) {
        console.error(" Failed to fetch cities:", err);
        setCityList([]);
      }
    };
    fetchCities();
  }, [selectedCountryId, selectedStateId]);

  return (
    <div className="container mt-5 mb-5 pt-3">
      <section className="py1">
        <div className="container">
          <div className="d-flex justify-content-center w-100 text-center titsksd mb-3">
            <div className="">
              <div data-aos="fade-right">
                <img src="/assets/images/shpas.png" alt="Header" />
              </div>

              {fromType === "user" && (
                <div data-aos="fade-left">
                  <h6>
                    <b>
                      <i className="fa fa-plus-circle color"></i>{" "}
                    </b>{" "}
                    <b className="fontsmall ">Add Address</b>
                  </h6>
                </div>
              )}

              {fromType === "company" && (
                <div data-aos="fade-left">
                  <h2 className="fw-bold">Add Company Address</h2>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container mt-5 ">
          <div className="d-flex justify-content-center contact-form2">
            {fromType === "user" && (
              <form onSubmit={Formik.handleSubmit} className="">
                <div className="row">
                  <div className="form-group col-md-12 col-sm-12 col-12 login-text">
                    <label>
                      Address Type <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-4">
                      <div>
                        <input
                          type="radio"
                          id="option1"
                          name="selection"
                          value="1"
                          checked={Formik.values.selection === "1"}
                          onChange={Formik.handleChange}
                        />
                        <label htmlFor="option1" className="ms-1">
                          Home
                        </label>
                      </div>

                      <div>
                        <input
                          type="radio"
                          id="option2"
                          name="selection"
                          value="2"
                          checked={Formik.values.selection === "2"}
                          onChange={Formik.handleChange}
                        />
                        <label htmlFor="option2" className="ms-1">
                          Work
                        </label>
                      </div>

                      <div>
                        <input
                          type="radio"
                          id="option3"
                          name="selection"
                          value="3"
                          checked={Formik.values.selection === "3"}
                          onChange={Formik.handleChange}
                        />
                        <label htmlFor="option3" className="ms-1">
                          Other
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                    <label>
                      Country <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control forminputpad"
                      id="inputCountry"
                      value={Formik.values.country}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        Formik.setFieldValue("country", selectedId);
                        Formik.setFieldValue("state", "");
                        Formik.setFieldValue("city", "");
                        setSelectedCountryId(selectedId);
                      }}
                    >
                      <option value="" disabled>Select</option>
                      {countryList.map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                    <label>
                      State <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control forminputpad"
                      id="inputState"
                      value={Formik.values.state}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        Formik.setFieldValue("state", selectedId);
                        Formik.setFieldValue("city", "");
                        setSelectedStateId(selectedId);
                      }}
                    >
                      <option value="" disabled>
                        {stateList.length ? "Select State" : "Select the Country first"}
                      </option>
                      {stateList.map((state) => (
                        <option key={state.id} value={state.id}>
                          {state.state}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                    <label>
                      City <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control forminputpad"
                      id="inputCity"
                      value={Formik.values.city}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        Formik.setFieldValue("city", selectedId);
                      }}
                    >
                      <option value="" disabled>
                        {cityList.length ? "Select City" : "Select the State first"}
                      </option>
                      {cityList.map((city) => (
                        <option key={city.id} value={city.id}>
                          {city.city}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group col-md-6 col-sm-6 col-6 login-text ">
                    <label>
                      Postal Code <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Postal code"
                      {...Formik.getFieldProps("postal_code")}
                    />
                  </div>
                </div>
                <div className="form-group submit login-text">
                  <label>
                    Address <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={5}
                    placeholder="Address"
                    {...Formik.getFieldProps("requirement")}
                  ></textarea>
                </div>

                <div className="d-flex justify-content-end">
                  <button className="text-white" type="submit">
                    {spinner ? (
                      <span className="spinner-border spinner-border-sm" role="status"></span>
                    ) : (
                      <b>Submit</b>
                    )}
                  </button>
                </div>
              </form>
            )}

            {fromType === "company" && (
              <form onSubmit={Formik2.handleSubmit} className="">
                <div className="row mb-3">
                  <div className="col-12">
                    <label className="fw-bold mb-2">Select User Type</label>
                    <div className="d-flex gap-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="user_role"
                          id="roleManufacturer"
                          value="1"
                          checked={selectedRole === "1"}
                          onChange={(e) => setSelectedRole(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor="roleManufacturer">
                          Manufacturer
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="user_role"
                          id="roleAgency"
                          value="2"
                          checked={selectedRole === "2"}
                          onChange={(e) => setSelectedRole(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor="roleAgency">
                          Agency
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="user_role"
                          id="roleDealers"
                          value="3"
                          checked={selectedRole === "3"}
                          onChange={(e) => setSelectedRole(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor="roleDealers">
                          Dealers
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-md-6 col-sm-6 col-6 login-text ">
                    <label>
                      Company Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Company Name"
                      {...Formik2.getFieldProps("Company_Name")}
                    />
                  </div>

                  <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                    <label>
                      GSTIN <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="GSTIN"
                      {...Formik2.getFieldProps("GSTIN")}
                    />
                  </div>

                  <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                    <label>
                      Phone Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Phone Number"
                      {...Formik2.getFieldProps("PhoneNumber")}
                    />
                  </div>

                  <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                    <label>
                      Alternate Phone Number
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Alternate Phone Number"
                      {...Formik2.getFieldProps("Alternate_Phone_Number")}
                    />
                  </div>

                  <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                    <label>
                      Country <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control forminputpad"
                      id="inputCountry2"
                      value={Formik2.values.country}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        Formik2.setFieldValue("country", selectedId);
                        Formik2.setFieldValue("state", "");
                        Formik2.setFieldValue("city", "");
                        setSelectedCountryId(selectedId);
                      }}
                    >
                      <option value="" disabled>Select Country</option>
                      {countryList.map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                    <label>
                      State <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control forminputpad"
                      id="inputState2"
                      value={Formik2.values.state}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        Formik2.setFieldValue("state", selectedId);
                        Formik2.setFieldValue("city", "");
                        setSelectedStateId(selectedId);
                      }}
                    >
                      <option value="" disabled>Select State</option>
                      {stateList.map((state) => (
                        <option key={state.id} value={state.id}>
                          {state.state}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                    <label>
                      City <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control forminputpad"
                      id="inputCity2"
                      value={Formik2.values.city}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        Formik2.setFieldValue("city", selectedId);
                      }}
                    >
                      <option value="" disabled>Select City</option>
                      {cityList.map((city) => (
                        <option key={city.id} value={city.id}>
                          {city.city}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group col-md-6 col-sm-6 col-6 login-text ">
                    <label>
                      Postal Code <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Postal code"
                      {...Formik2.getFieldProps("postal_code")}
                    />
                  </div>
                </div>
                <div className="form-group submit login-text">
                  <label>
                    Office Address <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={5}
                    placeholder="Address"
                    {...Formik2.getFieldProps("requirement")}
                  ></textarea>
                </div>

                <div className="d-flex justify-content-end">
                  <button className="text-white" type="submit">
                    {spinner ? (
                      <span className="spinner-border spinner-border-sm" role="status"></span>
                    ) : (
                      <b>Submit</b>
                    )}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddressForm;
